"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M22.134 16.295c.578-1.338.866-2.77.866-4.295 0-1.526-.288-2.957-.866-4.295a11.1 11.1 0 0 0-2.35-3.49 11.1 11.1 0 0 0-3.49-2.35A10.723 10.723 0 0 0 12 1c-1.526 0-2.957.289-4.295.866a11.1 11.1 0 0 0-3.49 2.35 11.1 11.1 0 0 0-2.35 3.49A10.723 10.723 0 0 0 1 12c0 1.526.289 2.957.866 4.295a11.1 11.1 0 0 0 2.35 3.49 11.1 11.1 0 0 0 3.49 2.35C9.042 22.71 10.473 23 12 23c1.526 0 2.957-.288 4.295-.866a11.1 11.1 0 0 0 3.49-2.35 11.095 11.095 0 0 0 2.35-3.49ZM15.16 8.307a1.05 1.05 0 1 1 1.513 1.453l-5.5 5.933a1.049 1.049 0 0 1-1.498.015l-2.331-2.331a1.049 1.049 0 1 1 1.483-1.484l1.574 1.574 4.759-5.16Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};